import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";

import { ChalkActionButton, ChalkCard } from "../components/chalk/primitives";
import { tbilling, usd } from "../lib/tournamentApi";

const CARDS = [["ok", "Test card ending 4242 (succeeds later charges)"], ["fail", "Test card ending 0341 (declines later charges)"]];

/** PREVIEW MOCK of Stripe Checkout for tournament billing. Never used in production. */
export default function TournamentCheckoutMock() {
  const [q] = useSearchParams();
  const sid = q.get("session");
  const [ck, setCk] = useState(null);
  const [card, setCard] = useState("ok");
  const [other, setOther] = useState(false);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  useEffect(() => { tbilling.checkout(sid).then(setCk).catch((e) => toast.error(e.message)); }, [sid]);
  async function pay() {
    setBusy(true);
    try {
      const r = await tbilling.previewComplete({ session_id: sid, card, fingerprint: other ? `fp_mock_other_${Date.now()}` : null });
      setResult(r);
      if (!r.rejected) window.location.href = ck.success_url;
    } catch (e) { toast.error(e.message); }
    finally { setBusy(false); }
  }
  if (!ck) return <div style={{ padding: 24 }}>Loading…</div>;
  const setup = ck.kind === "free_event";
  return (
    <div data-testid="tcheckout-page" style={{ maxWidth: 460, margin: "40px auto", padding: 16 }}>
      <div data-testid="tcheckout-mock-banner" style={{ background: "#FFF4D6", border: "1px solid #E8C468", borderRadius: 10, padding: 10, fontSize: 12, marginBottom: 14 }}>
        PREVIEW MOCK: no real card is charged. This stands in for Stripe Checkout.</div>
      <ChalkCard>
        <div style={{ fontSize: 12, color: "var(--chalk-muted)", textTransform: "uppercase", letterSpacing: "0.1em" }}>CHALKOS</div>
        <div data-testid="tcheckout-label" style={{ fontWeight: 700, fontSize: 18, marginTop: 4 }}>{ck.label}</div>
        <div data-testid="tcheckout-amount" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 44 }}>{setup ? "$0 today" : usd(ck.amount_cents)}</div>
        {setup && <div style={{ fontSize: 12, color: "var(--chalk-muted)", marginBottom: 10 }}>Saving your card for any post-event adjustment.</div>}
        {CARDS.map(([k, label]) => (
          <label key={k} style={{ display: "flex", gap: 8, fontSize: 13, margin: "6px 0" }}>
            <input type="radio" checked={card === k} onChange={() => setCard(k)} data-testid={`tcheckout-card-${k}`} /> {label}
          </label>
        ))}
        <label style={{ display: "flex", gap: 8, fontSize: 12, margin: "8px 0 14px", color: "var(--chalk-muted)" }}>
          <input type="checkbox" checked={!other} onChange={(e) => setOther(!e.target.checked)} data-testid="tcheckout-same-card" />
          Simulate the same physical card as this account's earlier test card
        </label>
        <ChalkActionButton label={busy ? "Processing…" : setup ? "Save card" : `Pay ${usd(ck.amount_cents)}`} testId="tcheckout-pay" disabled={busy || ck.status !== "pending"} onClick={pay} />
        {result?.rejected && (
          <div data-testid="tcheckout-rejected" style={{ color: "#B22222", fontSize: 13, marginTop: 10 }}>
            {result.rejected === "card_already_used" ? "This card was already used for a free Hub event on another account. Choose Hub for this event instead." : "The free event isn't available."}
          </div>
        )}
        {ck.status !== "pending" && <div data-testid="tcheckout-done" style={{ fontSize: 13, marginTop: 10 }}>This checkout is {ck.status}.</div>}
      </ChalkCard>
    </div>
  );
}
